import React, { useState, useEffect } from "react";
import axiosInstance from "../../../global/common/interceptor";
import { Button, Table, Modal, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MdDelete, MdEdit, MdHomeFilled, MdVisibility } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import apiService from "../../../global/common/environment";
import "./OnlineCourses.scss";

const OnlineCourses = () => {
  const [Courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const coursesPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    getCourses();
  }, []);

  useEffect(() => {
    setFilteredCourses(
      Courses.filter(
        (course) =>
          course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          course.collageName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setCurrentPage(1);
  }, [searchTerm, Courses]);

  const getCourses = async () => {
    try {
      const response = await axiosInstance.get(apiService.getMscourse);
      const sortedCourses = response.data.sort((a, b) => b._id.localeCompare(a._id));
      setCourses(sortedCourses);
      setFilteredCourses(sortedCourses);
    } catch (error) {
      console.error("Error fetching Courses:", error);
    }
  };

  const deleteCourse = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Course!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axiosInstance.delete(apiService.deleteMsCourse(id));
          getCourses();
          Swal.fire("Deleted!", "Your Course has been deleted.", "success");
        } catch (error) {
          console.error("Error deleting Course:", error);
          Swal.fire("Error!", "Failed to delete the Course. Please try again.", "error");
        }
      }
    });
  };

  const handleEditRedirect = (courseId) => {
    navigate(`/admin/onlinedetailpage/${courseId}`);
  };

  const handleAddProgram = () => {
    navigate("/admin/onlinedetailpage");
  };

  const handleViewCourse = (course) => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCourse(null);
  };

  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = filteredCourses.slice(indexOfFirstCourse, indexOfLastCourse);
  const totalPages = Math.ceil(filteredCourses.length / coursesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="course-schema-form-container mt-5">
      <div className="d-flex justify-content-between">
        <h1>Online Course</h1>
        <Form.Control
          type="text"
          placeholder="Search Courses or College Name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-25"
        />
        <Button variant="primary" onClick={handleAddProgram}>
          Add Online Courses
        </Button>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>SNo</th>
            <th>Course Name</th>
            <th>Price</th>
            <th>Currency</th>
            <th>Description</th>
            <th>Collage Name</th>
            <th>Categories</th>
            <th>Homepage view</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentCourses.map((Course, i) => (
            <tr key={Course._id}>
              <td>{indexOfFirstCourse + i + 1}</td>
              <td>{Course.title}</td>
              <td>{Course.price}</td>
              <td>{Course.currency}</td>
              <td
                dangerouslySetInnerHTML={{
                  __html:
                    Course.description?.length > 50
                      ? `${Course.description.substring(0, 50)}...`
                      : Course.description,
                }}
              ></td>
              <td>{Course.collageName}</td>
              <td>{Course.categories[0] || "NA"}</td>
              <td>
  <Button
    variant={Course.viewOnHomePage ? "success" : "danger"}
    className="home-view-btn"
  >
    {Course.viewOnHomePage ? "Yes" : "No"}
  </Button>
</td>

              <td>
                <img
                  src={Course.image}
                  alt="Course"
                  style={{ width: "100px" }}
                />
              </td>

              <td>
                <Button
                  variant="warning"
                  onClick={() => handleEditRedirect(Course._id)}
                >
                  <MdEdit />
                </Button>
                <Button
                  variant="danger"
                  onClick={() => deleteCourse(Course._id)}
                  className="ms-2"
                >
                  <MdDelete />
                </Button>

                <Button
                  variant="info"
                  onClick={() => handleViewCourse(Course)}
                  className="ms-2"
                >
                  <MdVisibility />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for Viewing Course Details */}
      <Modal show={showModal} onHide={handleCloseModal} className="modal">
        <Modal.Header closeButton>
          <Modal.Title>Course Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCourse && (
            <div>
              <p>
                <strong>Title:</strong> {selectedCourse.title}
              </p>

              <p>
                <strong>Price:</strong> {selectedCourse.price}
              </p>
              <p>
                <strong>Duration:</strong> {selectedCourse.duration}
              </p>
              <p>
                <strong>language:</strong> {selectedCourse.language}
              </p>
              <p>
                <strong>Description:</strong>{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: selectedCourse.description,
                  }}
                ></span>
              </p>
              <p>
                <strong>curriculum:</strong>{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: selectedCourse.curriculum,
                  }}
                ></span>
              </p>
              <p>
                <strong>Requirements:</strong>{" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: selectedCourse.requirements,
                  }}
                ></span>
              </p>
              <p>
                <strong>Collage Name:</strong> {selectedCourse.collageName}
              </p>
              <p>
                <strong>Categories:</strong>{" "}
                {selectedCourse.categories.join(", ")}
              </p>
              <img
                src={selectedCourse.image}
                alt="Course"
                style={{ width: "100%" }}
              />
              <br />
              <br />
              <p>
                <strong>Logo :</strong>
                <img
                  src={selectedCourse.logo}
                  alt="Course"
                  style={{ width: "50%" }}
                />
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Pagination */}
      <div className="d-flex justify-content-center">
        <Button
          variant="secondary"
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        {Array.from({ length: totalPages }).map((_, index) => (
          index >= currentPage - 2 && index <= currentPage && (
            <Button
              key={index}
              variant={currentPage === index + 1 ? "primary" : "light"}
              onClick={() => paginate(index + 1)}
              className="mx-1"
            >
              {index + 1}
            </Button>
          )
        ))}
        <Button
          variant="secondary"
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default OnlineCourses;
